import { TbPencilSearch } from "react-icons/tb";
import Modal from "../interface/Modal";
import { useState } from "react";
import styled from "styled-components";
import ImageEdit from "../modules/authentication/ImageEdit";

const ImageButton = styled.button`
  position: absolute;
  bottom: -3px;
  left: 0;
  right: 0;
  margin: auto;
  width: fit-content;
  padding: 0.35rem;
  border-radius: 50%;
  background-color: var(--color-grey-50);
  border: 1px solid var(--color-grey-500);
  &:hover {
    background-color: var(--color-grey-500);
  }
`;

function TestingOnly() {
  const [userImage, setUserImage] = useState(null);
  function handleUpdateAvatar(editedImage) {
    setUserImage(editedImage);
  }

  return (
    <div>
      <Modal>
        <Modal.Open opens="editImage">
          <ImageButton type="button">
            <TbPencilSearch />
          </ImageButton>
        </Modal.Open>
        <Modal.Window name="editImage">
          <ImageEdit updateAvatar={handleUpdateAvatar} />
        </Modal.Window>
      </Modal>
    </div>
  );
}

export default TestingOnly;
